import axios from 'axios';
import { AsyncAction } from '..';

type State = {
    fetching: boolean;
    items: string[];
    error?: Error;
};

type Action = {
    type: 'plan_activity/get';
    payload?: { items: string[] };
    error?: Error;
};

const initialState: State = {
    fetching: false,
    items: [],
};

export const reducer = (state = initialState, action: Action): State => {
    switch (action.type) {
        case 'plan_activity/get':
            if (action.payload) return { ...state, fetching: false, ...action.payload };
            if (action.error) return { ...state, fetching: false, error: action.error };
            return { ...state, fetching: true };
        default:
            return state;
    }
};

/**
 * Request inspection activity types.
 * 
  @param rethrow throw the internal error, causing the promise generated by the dispatch to fail
 */
const get = (rethrow = false): AsyncAction => async dispatch => {
    try {
        dispatch({ type: 'plan_activity/get' });
        const cancel = axios.CancelToken.source();
        dispatch({ type: 'cancel/set', payload: { 'plan_activity/get': cancel } });
        const response = await axios.get<string[]>('/inspection-activities/inspection_types/', {
            cancelToken: cancel.token,
        });
        dispatch({ type: 'plan_activity/get', payload: { items: response.data } });
    } catch (error) {
        dispatch({ type: 'plan_activity/get', error });
        if (rethrow) throw error;
    }
};

export const creators = { get };
